const FREE_PLAN_WEIGHT = 10;

export const hasPaidPlanAccess = (userPlan) => {
  if (!userPlan || typeof userPlan !== 'object') return false;
  const planId = String(userPlan.plan_id || '').trim().toLowerCase();
  const weight = Number(userPlan.weight);
  return Boolean(planId && planId !== 'free' && Number.isFinite(weight) && weight > FREE_PLAN_WEIGHT);
};

